import { render, staticRenderFns } from "./TeamRegistrationDialog.vue?vue&type=template&id=ba4220ea&scoped=true"
import script from "./TeamRegistrationDialog.vue?vue&type=script&lang=js"
export * from "./TeamRegistrationDialog.vue?vue&type=script&lang=js"
import style0 from "./TeamRegistrationDialog.vue?vue&type=style&index=0&id=ba4220ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4220ea",
  null
  
)

export default component.exports